import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, withCtx as _withCtx, renderList as _renderList, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "block-pageHeader" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "dt-topLink" }
const _hoisted_4 = {
  key: 0,
  style: {"padding-top":"0"},
  class: "block-pageHeader__title mt30"
}
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "dt__listPage" }
const _hoisted_7 = { class: "dt__listPage-control" }
const _hoisted_8 = { class: "dt__listPage-control-left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "dt-mapIcon" }, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Показать на карте", -1 /* HOISTED */)
const _hoisted_11 = { class: "dt__listPage-control-right" }
const _hoisted_12 = { class: "dt__listPage-count" }
const _hoisted_13 = { class: "dt__listPage-list" }
const _hoisted_14 = { class: "dt__listPage-list-item dt__listPage-list-item_desktop" }
const _hoisted_15 = { class: "dt__listPage-list-item-info" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "dt__listPage-list-item-info-content" }
const _hoisted_18 = { class: "dt__listPage-list-item-info-content-cards" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "dt-cardIcon" }, null, -1 /* HOISTED */)
const _hoisted_20 = { class: "dt__listPage-list-item-control" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "dt-mapIcon" }, null, -1 /* HOISTED */)
const _hoisted_22 = { class: "dt__listPage-list-item-cards" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "dt-cardIcon" }, null, -1 /* HOISTED */)
const _hoisted_24 = { class: "dt__listPage-list-item-footer" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "В раздел", -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "dt-strIcon" }, null, -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "На карте", -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "dt-strIcon" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_skeleton_title = _resolveComponent("skeleton-title")!
  const _component_skeleton_list_head = _resolveComponent("skeleton-list-head")!
  const _component_skeleton_list = _resolveComponent("skeleton-list")!
  const _component_description = _resolveComponent("description")!
  const _component_page_search = _resolveComponent("page-search")!
  const _component_sort_component = _resolveComponent("sort-component")!
  const _component_paginate = _resolveComponent("paginate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!this.loading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "block-pageHeader__img block-pageHeader__img_digitalTwin",
            style: _normalizeStyle({backgroundImage: 'url(' + this.category.image.url + ')'})
          }, null, 4 /* STYLE */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: 'main-page'},
            class: "block-btnNavBack"
          }),
          (!this.loading)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(this.category.name), 1 /* TEXT */))
            : (_openBlock(), _createBlock(_component_skeleton_title, { key: 1 }))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (this.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_skeleton_list_head),
              _createVNode(_component_skeleton_list)
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_description, {
                description: _ctx.category.description
              }, null, 8 /* PROPS */, ["description"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_page_search, {
                    pages: this.category.pages,
                    placeholder: 'Поиск по названию разделов',
                    class: "dt__listPage-control-desktop"
                  }, null, 8 /* PROPS */, ["pages"]),
                  _createVNode(_component_router_link, {
                    to: this.category.getMapUrl(),
                    class: "dt__iconNav"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _hoisted_10
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["to"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_page_search, {
                    pages: this.category.pages,
                    placeholder: 'Поиск по названию разделов',
                    class: "dt__listPage-control-mobile"
                  }, null, 8 /* PROPS */, ["pages"]),
                  _createVNode(_component_sort_component, {
                    modelValue: this.category.sortMode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.category.sortMode) = $event)),
                    onApply: $options.onApplySort,
                    list: _ctx.category.allowedSortModes
                  }, null, 8 /* PROPS */, ["modelValue", "onApply", "list"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, "Всего " + _toDisplayString(this.category.pages.length), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.category.pages, (page) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_router_link, {
                          to: { name: 'page', params: page.identity },
                          class: "dt__listPage-list-item-info-icon"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: page.image.url
                            }, null, 8 /* PROPS */, _hoisted_16)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_router_link, {
                            to: { name: 'page', params: page.identity },
                            class: "dt__listPage-list-item-info-content-title"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(page.name), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("span", null, _toDisplayString(page.countItems), 1 /* TEXT */)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_router_link, {
                          to: { name: 'page', params: page.identity },
                          class: "button button-primary button-block"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Подробнее ")
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                        _createVNode(_component_router_link, {
                          to: { name: 'page-map', params: page.identity },
                          class: "dt__listPage-list-item-control-mapLink"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "dt__listPage-list-item dt__listPage-list-item_mobile",
                      style: _normalizeStyle({backgroundImage:`linear-gradient(0deg, rgba(66, 66, 66, 0.5), rgba(66, 66, 66, 0.5)), url(${page.image.url})`, backgroundRepeat: 'no-repeat', })
                    }, [
                      _createVNode(_component_router_link, {
                        to: { name: 'page', params: page.identity },
                        onClick: $options.onClickLink,
                        class: "dt__listPage-list-item-wrapper"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("span", null, _toDisplayString(page.countItems), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["dt__listPage-list-item-title", this.activeLink ? 'active' : ''])
                          }, _toDisplayString(page.name), 3 /* TEXT, CLASS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "onClick"]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_router_link, {
                          to: { name: 'page', params: page.identity },
                          class: "dt__listPage-list-item-footer-item"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25,
                            _hoisted_26
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                        _createVNode(_component_router_link, {
                          to: { name: 'page-map', params: page.identity },
                          class: "dt__listPage-list-item-footer-item"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_27,
                            _hoisted_28
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                      ])
                    ], 4 /* STYLE */)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 256 /* UNKEYED_FRAGMENT */)),
                (_openBlock(), _createBlock(_component_paginate, {
                  key: this.key,
                  modelValue: this.page,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.page) = $event)),
                  "page-count": Math.ceil(this.total / this.count),
                  "page-range": 5,
                  "margin-pages": 1,
                  "click-handler": $options.changePage,
                  "prev-text": 'Назад',
                  "next-text": 'Дальше',
                  "container-class": 'pagination-vue',
                  "page-class": 'pagination-vue__item'
                }, null, 8 /* PROPS */, ["modelValue", "page-count", "click-handler"]))
              ])
            ], 64 /* STABLE_FRAGMENT */))
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}